import { createElementBlock as t, openBlock as l, createElementVNode as e } from "vue";
import o from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(f, c, i, p, a, m) {
  return l(), t("svg", n, c[0] || (c[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#DAE7F1",
        d: "M24.2 30.047V18c0-3.313 2.82-6 6.3-6s6.3 2.687 6.3 6v12.047C39.338 31.872 41 34.74 41 38c0 5.523-4.701 10-10.5 10S20 43.523 20 38c0-3.259 1.663-6.13 4.2-7.953Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M30.5 10.75c4.157 0 7.55 3.232 7.55 7.25v11.428l.277.23c2.38 2.036 3.821 4.899 3.918 8.008l.005.334c0 6.227-5.274 11.25-11.75 11.25S18.75 44.227 18.75 38c0-3.349 1.561-6.44 4.182-8.558l.017-.014V18c0-3.938 3.26-7.12 7.303-7.246Zm0 2.5c-2.803 0-5.05 2.14-5.05 4.75v12.047c0 .402-.194.78-.52 1.015-2.307 1.659-3.68 4.193-3.68 6.938 0 4.818 4.128 8.75 9.25 8.75s9.25-3.932 9.25-8.75c0-2.746-1.372-5.279-3.68-6.938a1.25 1.25 0 0 1-.52-1.015V18c0-2.61-2.247-4.75-5.05-4.75Zm0 13.5c.647 0 1.18.493 1.244 1.123l.006.128v4.888a5.487 5.487 0 0 1 2.583 1.378 5.116 5.116 0 0 1 0 7.467c-2.124 2.022-5.543 2.022-7.664 0a5.116 5.116 0 0 1 0-7.467 5.483 5.483 0 0 1 2.582-1.378l-.001-4.888c0-.69.56-1.25 1.25-1.25Zm-2.107 9.327c-1.124 1.07-1.124 2.777 0 3.847 1.157 1.102 3.058 1.102 4.216 0 1.078-1.027 1.121-2.641.129-3.715l-.13-.132-.148-.132c-1.166-.968-2.959-.924-4.067.132Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ o(r, [["render", s]]);
export {
  _ as default
};
